<template>
  <v-footer
    absolute
    app
  >
    <span>{{ $t("footer.copyright") }}</span>
  </v-footer>
</template>

<script>
export default {
    name: 'Footer',
};
</script>
